module.exports = __webpack_public_path__ + "static/media/captureMaskWhite.4d9a2b68.png";